import styled from 'styled-components';
import withAnimation from '@shared/components/utils/hoc/withAnimation';

const GuideChannelRailAndLogoContainer = styled.div<React.CSSProperties>``;

export default withAnimation(GuideChannelRailAndLogoContainer);
